import axios from 'axios';

export const CHAT_V3_API_BASE_URL = 'https://us-central1-audio-twinkle.cloudfunctions.net/chatV3Api';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://us-central1-audio-twinkle.cloudfunctions.net/api';

const applyAuthorizationHeader = (config) => {
    const authorization = axios.defaults.headers.common['Authorization'];
    if (authorization) {
        config.headers = {
            ...config.headers,
            Authorization: authorization
        };
    }
    return config;
};

export const api = axios.create({
    baseURL: API_BASE_URL
});

api.interceptors.request.use(applyAuthorizationHeader);
